<template>
  <div id="wrapper" v-if="sectionInfo && isVisible" v-on-display="{sectionInfo, context: this}">
    <div class="inner-wrap">
      <div class="title">
        <h1 v-band-title class="title-area" tabindex="0">
          <span class="label">{{multiSectionTitle}}</span>
        </h1>
      </div>
      <div class="band-board-content">
        <table>
          <caption>KBO 팀 순위표</caption>
          <colgroup>
            <col style="width: 126px;">
            <col>
            <col style="width: 126px;">
            <col style="width: 126px;">
            <col style="width: 126px;">
            <col style="width: 126px;">
            <col style="width: 126px;">
            <col style="width: 126px;">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">순위</th>
              <th scope="col">팀</th>
              <th scope="col">경기수</th>
              <th scope="col">승</th>
              <th scope="col">무</th>
              <th scope="col">패</th>
              <th scope="col">승률</th>
              <th scope="col">게임차</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(team, index) in teamRankList" :key="'rank_' + index">
              <td>{{team.rank}}</td>
              <td>
                <img :src="team.image" class="team-logo" :alt="team.name + ' 아이콘'" />
                <span>{{team.name}}</span>
              </td>
              <td>{{team.game}}</td>
              <td>{{team.win}}</td>
              <td>{{team.draw}}</td>
              <td>{{team.lose}}</td>
              <td>{{team.wra}}</td>
              <td>{{team.gap}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
  import { bandTitle, onDisplay } from '@/common/resources/directives'
  import { fetchOnContent } from '@/common/utils/request.common'
  import { getTeamRanking } from '@/common/utils/baseball'
  import MultiSectionMixin from '@/mixins/multisection.mixin'

  export default {
    name: 'TemplateKboTeamRank',
    mixins: [
      MultiSectionMixin
    ],
    directives: {
      onDisplay,
      bandTitle
    },
    props: {
      sectionInfo: {
        type: Object
      }
    },
    data () {
      return {
        teamRankList: [],
        response: null
      }
    },
    methods: {
      async setData () {
        const response = await fetchOnContent(this.sectionInfo)
        this.teamRankList = getTeamRanking(response)
      }
    },
    computed: {
      isVisible () {
        return this.teamRankList.length > 0
      }
    },
    created () {
      this.setData()
    }
  }
</script>
